<template>
  <component
    v-bind:is="handleDashboard"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import AdminDashboard from './AdminDashboard';
import VivuDasboard from './VivuDasboard';
import WorkerDasboard from './WorkerDasboard';

export default {
  name: 'DashboardScreen',
  components: {
    AdminDashboard,
    VivuDasboard,
    WorkerDasboard,
  },
  props: {},
  data() {
    return {};
  },
  created() {
  },
  mounted() {},
  computed: {
    ...mapGetters({
      loggedInUser: 'loggedInUser',
    }),
    handleDashboard() {
      if (this.loggedInUser && this.loggedInUser.role === 'worker') {
        return 'worker-dasboard';
      }
      if (this.loggedInUser && this.loggedInUser.role === 'vivu') {
        return 'vivu-dasboard';
      }
      if (this.loggedInUser && (this.loggedInUser.role === 'admin' || this.loggedInUser.role === 'partner_admin')) {
        return 'admin-dashboard';
      }
      return null;
    },
  },
  methods: {
  },
  watch: {
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/modules/dashboard/DashboardScreen.vue